import React from 'react';

import {Prompt} from 'react-router-dom';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import Header, {headerItemsLabels} from '../../../../Common/Header/header';
import Overlay from 'infrastructure/js/components/Overlay/overlay';
import {SettingsMenuItemsIds} from '../../../../../enums/navigationMenuItemsIds';
import {createPdfDetailedLabelSectionForm, computeInitialValues, convertToSettings} from '../Components/PdfDetailedLabelSectionForm/pdfDetailedLabelSectionForm';

require('./kitPdfDetailedLabelSettingsView.scss');


const HEADER_LIST_FIELD = 'headerPdfLabelsList';
const ROW_LIST_FIELD = 'rowPdfLabelsList';

const HeaderSectionForm = createPdfDetailedLabelSectionForm('pdfDetailedLabelHeaderForm', HEADER_LIST_FIELD);
const RowSectionForm = createPdfDetailedLabelSectionForm('pdfDetailedLabelRowForm', ROW_LIST_FIELD);


export default class KitPdfDetailedLabelSettingsView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.settings.pdfDetailedLabelSettings.view.');
    this.navigationLabels = createLabelHelper('mat.navigation.confirmation.');

    this.headerHandleSubmit = null;
    this.rowHandleSubmit = null;
  }

  onHeaderHandleSubmitReady = (handleSubmit) => {
    this.headerHandleSubmit = handleSubmit;
  };

  onRowHandleSubmitReady = (handleSubmit) => {
    this.rowHandleSubmit = handleSubmit;
  };

  componentDidMount() {
    this.props.actions.settingsPageActions.onSelectedMenuItemChanged(SettingsMenuItemsIds.NAV_ELEMENT_PDF_DETAILED_LABEL_KIT);
    this.props.actions.load();
  }

  componentWillUnmount() {
    this.props.actions.unmount();
  }

  isDirty = () => {
    return this.props.isHeaderDirty || this.props.isRowDirty;
  };

  onPreview = () => {
    this.props.actions.preview();
  };

  onSave = () => {
    let headerValid = false;
    let rowValid = false;

    if (this.headerHandleSubmit) {
      this.headerHandleSubmit(() => { headerValid = true; })();
    }
    if (this.rowHandleSubmit) {
      this.rowHandleSubmit(() => { rowValid = true; })();
    }

    if (!headerValid || !rowValid) {
      return;
    }

    let headerFormData = this.props.sData.get('headerFormData');
    let rowFormData = this.props.sData.get('rowFormData');

    let data = {
      headerSettings: convertToSettings(this.props.headerFormValues?.[HEADER_LIST_FIELD], headerFormData?.pdfOptions || []),
      rowSettings: convertToSettings(this.props.rowFormValues?.[ROW_LIST_FIELD], rowFormData?.pdfOptions || []),
    };

    this.props.actions.submit(data, this.getMessageDialogBuilder());
  };

  getMessageDialogBuilder = () => {
    return () => {
      let title = this.labels.get('confirmation.success.kit');
      let className = 'oneBackground';
      return {title, className};
    };
  };

  getHeaderItems = () => {
    return {
      
      title: this.labels.get('title.kit'),
      
      buttons: [
        {
          id: 'preview',
          label: headerItemsLabels.PREVIEW,
          className: 'no-icon',
          disabled: this.isDirty(),
          action: this.onPreview,
        },
        {
          id: 'save',
          label: headerItemsLabels.SAVE,
          className: 'no-icon',
          disabled: !this.isDirty(),
          action: this.onSave,
        },
      ],
      
    };
  };

  renderLoadingOverlay = () => {
    if (!this.props.sData.get('loading')) {
      return null;
    }
    return <Overlay.Loading />;
  };

  renderPrompt = () => {
    return (
      <Prompt
        when={this.isDirty()}
        message={() => this.navigationLabels.get('datanotsaved.text')}
      />
    );
  };

  renderHeaderSection = () => {
    let headerFormData = this.props.sData.get('headerFormData');
    if (!headerFormData) {
      return null;
    }

    return (
      <HeaderSectionForm
        formData={headerFormData}
        initialValues={computeInitialValues(headerFormData, HEADER_LIST_FIELD)}
        labels={this.labels}
        sectionTitle={this.labels.get('section.header.title')}
        listFieldName={HEADER_LIST_FIELD}
        onHandleSubmitReady={this.onHeaderHandleSubmitReady}
      />
    );
  };

  renderRowSection = () => {
    let rowFormData = this.props.sData.get('rowFormData');
    if (!rowFormData) {
      return null;
    }

    return (
      <RowSectionForm
        formData={rowFormData}
        initialValues={computeInitialValues(rowFormData, ROW_LIST_FIELD)}
        labels={this.labels}
        sectionTitle={this.labels.get('section.table.title')}
        listFieldName={ROW_LIST_FIELD}
        onHandleSubmitReady={this.onRowHandleSubmitReady}
      />
    );
  };

  render() {
    let headerItems = this.getHeaderItems();

    return (
      <div className='kit-pdf-detailed-label-settings-view'>

        <Header {...headerItems}/>

        <div className='kit-pdf-detailed-label-settings-container'>
          {this.renderHeaderSection()}
          {this.renderRowSection()}
        </div>

        {this.renderLoadingOverlay()}
        {this.renderPrompt()}
        
      </div>
    );
  }
}
